/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Cloudflare_Email_Api_TokenInputs */

const en_admin_settings_fields_cloudflare_email_api_token = /** @type {(inputs: Admin_Settings_Fields_Cloudflare_Email_Api_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Token`)
};

const zh_admin_settings_fields_cloudflare_email_api_token = /** @type {(inputs: Admin_Settings_Fields_Cloudflare_Email_Api_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Token`)
};

/**
* | output |
* | --- |
* | "API Token" |
*
* @param {Admin_Settings_Fields_Cloudflare_Email_Api_TokenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_cloudflare_email_api_token = /** @type {((inputs?: Admin_Settings_Fields_Cloudflare_Email_Api_TokenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Cloudflare_Email_Api_TokenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_cloudflare_email_api_token(inputs)
	return zh_admin_settings_fields_cloudflare_email_api_token(inputs)
});
export { admin_settings_fields_cloudflare_email_api_token as "admin.settings.fields.cloudflare_email_api_token" }